<template>
  <div>
    <span :id="blockId + '-label'" class="sr-only">{{ $t('projects.block_type_rich_text') }}</span>
    <tip-tap-editor-component v-model="html" :aria-labelledby="blockId + '-label'"></tip-tap-editor-component>
  </div>
</template>

<script>
import TipTapEditorComponent from "@/components/editor/TipTapEditorComponent";

// Bloque de texto enriquecido (key `rich_text`, data `{ html }`, LMS-068).
export default {
  name: "RichTextBlock",
  components: {
    TipTapEditorComponent
  },
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    blockId: {
      type: String,
      required: true
    },
    lessonUuid: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    html: {
      get() {
        return this.modelValue.html ?? ''
      },
      set(html) {
        this.$emit('update:modelValue', {...this.modelValue, html})
      }
    }
  }
}
</script>
